// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28TCK","questions":"styles_questions__wt55a","footer":"styles_footer__iVBe-"};